const AppConstant={
EMAIL_PASSWORD_VALIDATION :"EMAIL_PASSWORD_VALIDATION",
SIGN_IN:"SIGN_IN", 
EMAIL: "EMAIL",
PASSWORD: "PASSWORD",
NO_ACCOUNT: "NO_ACCOUNT",
SEND_INVITATION:"SEND_INVITATION",
FORGOT_PASSWORD:"FORGOT_PASSWORD",
RESET_PASSWORD:"RESET_PASSWORD",
USE_KEGTRON_PRODUCTS:"USE_KEGTRON_PRODUCTS",
TERMS_AND_SERVICES : "TERMS_AND_SERVICES",
REGISTER:"REGISTER",
THANKYOU_FOR_CHECK_INBOX:"THANKYOU_FOR_CHECK_INBOX",
SITE: "SITE",
STATUS:"STATUS",
KEGS:"KEGS",
LOW:"LOW",
EMPTY:"EMPTY",
NO_SITES:"NO_SITES",
NO_DEVICES:"NO_DEVICES",
SITES:"SITES",
REPORTS:"REPORTS",
BY_KEG_SHORT:"BY_KEG_SHORT",
BY_TIME_SHORT:"BY_TIME_SHORT",
INVENTORY:"INVENTORY",
TODAY:"TODAY",
YESTERDAY:"YESTERDAY",
WEEK_TO_DATE:"WEEK_TO_DATE",
MONTH_TO_DATE:"MONTH_TO_DATE",
YEAR_TO_DATE:"YEAR_TO_DATE",
CUSTOM:"CUSTOM",
RANGE:"RANGE",
START:"START",
END:"END",
DATE:"DATE",
START_OF_BUSINESS_DAY:"START_OF_BUSINESS_DAY",
START_OF_BIZ_DAY:"START_OF_BIZ_DAY",
START_TIME:"START_TIME",
USE_TIME_RANGE:"USE_TIME_RANGE",
END_TIME:"END_TIME",
TIME:"TIME",
PRINT:"PRINT",
EXPORT_AS_CSV:"EXPORT_AS_CSV",
TAP_HANDLE_NUMBER:"TAP_HANDLE_NUMBER",
NAME:"NAME",
SERVING_SIZE:"SERVING_SIZE",
TOTAL_SERVINGS:"TOTAL_SERVINGS",
TOTAL_VOLUME:"TOTAL_VOLUME",
KEG_NAME:"KEG_NAME",
SERVINGS:"SERVINGS",
VOLUME_SERVED:"VOLUME_SERVED",
LITRES_SERVED:"LITRES_SERVED",
GALLONS_SERVED:"GALLONS_SERVED",
OUNCES_SERVED:"OUNCES_SERVED",
SITE_NAME:"SITE_NAME",
GRAND_TOTAL_BY_SITE:"GRAND_TOTAL_BY_SITE",
NO_DATA_AVAILABLE_FOR_SELECTED_RANGE:"NO_DATA_AVAILABLE_FOR_SELECTED_RANGE",
FETCHING_DATA:"FETCHING_DATA",
LOADING_SERVINGS_DATA:"LOADING_SERVINGS_DATA",
LOADING_DEVICE_PROGRESS:"LOADING_DEVICE_PROGRESS",
TAP:"TAP",
TOTAL:"TOTAL",
GRAND_TOTAL_BY_KEG:"GRAND_TOTAL_BY_KEG",
GRAND_TOTAL:"GRAND_TOTAL",
SERVING_REPORT:"SERVING_REPORT",
INVENTORY_REPORT:"INVENTORY_REPORT",
SERVED_REPORT:"SERVED_REPORT",
DISTRIBUTOR:"DISTRIBUTOR",
COST:"COST",
LEVEL:"LEVEL",
VALUE:"VALUE",
TOTAL_KEGS:"TOTAL_KEGS",
TOTAL_VALUE:"TOTAL_VALUE",
KEG_COUNT:"KEG_COUNT",
KEGRON_SERVING_REPORT_FILE:"KEGRON_SERVING_REPORT_FILE",
KEGTRON_SERVING_REPORT:"KEGTRON_SERVING_REPORT",
ADD_DEVICE:"ADD_DEVICE",
ACCOUNT:"ACCOUNT",
LOGOUT:"LOGOUT",
GO_TO_YOUR_SETTINGS:"GO_TO_YOUR_SETTINGS",
JOIN_WIFI_NETWORK:"JOIN_WIFI_NETWORK",
RETURN_TO_THIS_SCREEN:"RETURN_TO_THIS_SCREEN",
SCAN:"SCAN",
BACK:"BACK",
FOUND_NEW_DEVICE:"FOUND_NEW_DEVICE",
WIFI_NETWORK_NAME:"WIFI_NETWORK_NAME",
WIFI_PASSWORD:"WIFI_PASSWORD",
WIFI_SETTING_APPLIED:"WIFI_SETTING_APPLIED",
JOIN_BACK_TO_YOUR_WIFI_NETWORK:"JOIN_BACK_TO_YOUR_WIFI_NETWORK",
RETURN_TO_THIS_SCREEN_AND_CLICK_ON_REGISTER_DEVICE:"RETURN_TO_THIS_SCREEN_AND_CLICK_ON_REGISTER_DEVICE",
REGISTER_DEVICE:"REGISTER_DEVICE",
ERROR_REGISTERING_DEVICE:"ERROR_REGISTERING_DEVICE",
JOIN_YOUR_WIFI_NETWORK_AND_RETRY:"JOIN_YOUR_WIFI_NETWORK_AND_RETRY",
CONFIGURE_DEVICE_WIFI:"CONFIGURE_DEVICE_WIFI",
CHANGE_PASSWORD:"CHANGE_PASSWORD",
TYPE_NEW_PASSWORD:"TYPE_NEW_PASSWORD",
RETYPE_PASSWORD:"RETYPE_PASSWORD",
API_KEY:"API_KEY",
APPEARANCE:"APPEARANCE",
THEME:"THEME",
DARK_MODE:"DARK_MODE",
LIGHT_MODE:"LIGHT_MODE",
COPIED:"COPIED",
CLICK_TO_COPY:"CLICK_TO_COPY",
SURE_WANT_TO_UPDATE_YOUR_PASSWORD:"SURE_WANT_TO_UPDATE_YOUR_PASSWORD",
PASSWORD_FIELDS_CANNOT_BE_BLANK:"PASSWORD_FIELDS_CANNOT_BE_BLANK",
PASSWORD_DONT_MATCH:"PASSWORD_DONT_MATCH",
TIMESTAMP:"TIMESTAMP",
MESSAGE:"MESSAGE",
DESCRIPTION:"DESCRIPTION",
PRODUCER:"PRODUCER",
STYLE:"STYLE",
ABV:"ABV",
IBU:"IBU",
SRM:"SRM",
TEMP:"TEMP",
HUMIDITY:"HUMIDITY",
MODAL:"MODAL",
PORT:"PORT",
WIFI_SSID:"WIFI_SSID",
RSSI:"RSSI",
STARTING_VOLUME:"STARTING_VOLUME",
REMAINING_VOLUME:"REMAINING_VOLUME",
LAST_CLEANED:"LAST_CLEANED",
DAYS_ON_TAP:"DAYS_ON_TAP",
KEGS_SERVED:"KEGS_SERVED",
LAST_SERVING:"LAST_SERVING",
RESET_KEG_VOLUME:"RESET_KEG_VOLUME",
GRAPH:"GRAPH",
NOW:"NOW",
SERVING_HISTORY:"SERVING_HISTORY",
RECENT_SERVINGS:"RECENT_SERVINGS",
VOLUME_HISTORY:"VOLUME_HISTORY",
YOUR_DEVICE_REQUIRE_A_FIRMWARE_UPDATE:"YOUR_DEVICE_REQUIRE_A_FIRMWARE_UPDATE",
ONLINE:"ONLINE",
OFFLINE:"OFFLINE",
PORTS:"PORTS",
HARDWARE_REV:"HARDWARE_REV",
FIRMWARE_REV:"FIRMWARE_REV",
SR_NO:"SR_NO",
HUMIDITY_OFFSET:"HUMIDITY_OFFSET",
TEMPERATURE_OFFSET:"TEMPERATURE_OFFSET",
FOR_BEST_AUTO_RESET_PERFORMANCE_ALERT_MSG:"FOR_BEST_AUTO_RESET_PERFORMANCE_ALERT_MSG",
TIME_BETWEEN_SERVINGS_SEC:"TIME_BETWEEN_SERVINGS_SEC",
ALERT_EMAIL:"ALERT_EMAIL",
ALERT_TEXT_SMS:"ALERT_TEXT_SMS",
SMS_PHONE_NUMBERS_INVALID:"SMS_PHONE_NUMBERS_INVALID",
SMS_NUMBER_FORMAT_HINT:"SMS_NUMBER_FORMAT_HINT",
LOW_THRESSHOLD:"LOW_THRESSHOLD",
EMPTY_THRESHOLD:"EMPTY_THRESHOLD",
HIGH_TEMPERATURE_THRESHOLD:"HIGH_TEMPERATURE_THRESHOLD",
LOW_TEMPERATURE_THRESHOLD:"LOW_TEMPERATURE_THRESHOLD",
HIGH_PRESSURE_A_THRESHOLD:"HIGH_PRESSURE_A_THRESHOLD",
LOW_PRESSURE_A_THRESHOLD:"LOW_PRESSURE_A_THRESHOLD",
HIGH_PRESSURE_B_THRESHOLD:"HIGH_PRESSURE_B_THRESHOLD",
LOW_PRESSURE_B_THRESHOLD:"LOW_PRESSURE_B_THRESHOLD",
PRESSURE_A_TYPE:"PRESSURE_A_TYPE",
PRESSURE_B_TYPE:"PRESSURE_B_TYPE",
PRESSURE_TYPE_LOWPRESS:"PRESSURE_TYPE_LOWPRESS",
PRESSURE_TYPE_HIGHPRESS:"PRESSURE_TYPE_HIGHPRESS",
KEG_AGE_ALERT_THRESHOLD:"KEG_AGE_ALERT_THRESHOLD",
CLEANING_OVERDUE_ALERT_THRESHOLD:"CLEANING_OVERDUE_ALERT_THRESHOLD",
DURATION:"DURATION",
SUNDAY:"SUNDAY",
MONDAY:"MONDAY",
TUESDAY:"TUESDAY",
WEDNESDAY:"WEDNESDAY",
THURSDAY:"THURSDAY",
FRIDAY:"FRIDAY",
SATURDAY:"SATURDAY",
TIME_ZONE:"TIME_ZONE",
SAVE_CONFIGURATION:"SAVE_CONFIGURATION",
SCROLL_TO_TOP:"SCROLL_TO_TOP",
OK:"OK",
CANCEL:"CANCEL",
SITE_NAME_EDIT_ALERT_MSG:"SITE_NAME_EDIT_ALERT_MSG",
SEARCH_UNTAPPD:"SEARCH_UNTAPPD",
LOGIN_UNTAPPD:"LOGIN_UNTAPPD",
UNTAPPD_AUTH_ALERT_MSG:"UNTAPPD_AUTH_ALERT_MSG",
SEARCH_UNTAPPD_MODAL_HEADER:"SEARCH_UNTAPPD_MODAL_HEADER",
SEARCH_UNTAPPD_MODAL_PLACEHOLDER:"SEARCH_UNTAPPD_MODAL_PLACEHOLDER", 
SEARCH_UNTAPPD_NUM_RESULTS_MSG1:"SEARCH_UNTAPPD_NUM_RESULTS_MSG1",
SEARCH_UNTAPPD_NUM_RESULTS_MSG2:"SEARCH_UNTAPPD_NUM_RESULTS_MSG2",
UNTAPPD_SEARCH_MANY_RES_MSG1: "UNTAPPD_SEARCH_MANY_RES_MSG1",
UNTAPPD_SEARCH_MANY_RES_MSG2: "UNTAPPD_SEARCH_MANY_RES_MSG2",
UNTAPPD_SEARCH_MANY_RES_MSG3: "UNTAPPD_SEARCH_MANY_RES_MSG3",
UNTAPPD_SEARCH_NO_RES_MSG:"UNTAPPD_SEARCH_NO_RES_MSG",
UNTAPPD_SEARCH_LIMIT_MSG:"UNTAPPD_SEARCH_LIMIT_MSG",
UNTAPPD_SEARCH_ERROR_MSG:"UNTAPPD_SEARCH_ERROR_MSG",
TRANSFER_UNTAPPD_MODAL_HEADER:"TRANSFER_UNTAPPD_MODAL_HEADER",
TRANSFER_UNTAPPD_MODAL_MSG:"TRANSFER_UNTAPPD_MODAL_MSG", 
KEG_VOLUME_START:"KEG_VOLUME_START",
KEG_COST:"KEG_COST",
CAL_OFFSET:"CAL_OFFSET",
DATE_TAPPED:"DATE_TAPPED",
DATE_CLEANED:"DATE_CLEANED",
SURE_TO_RESET_KEGS_SERVED_COUNT:"SURE_TO_RESET_KEGS_SERVED_COUNT",
PLEASE_ENTER_A_VALID_TIME_DURATION_FOR_BUSINESS_HOURS:"PLEASE_ENTER_A_VALID_TIME_DURATION_FOR_BUSINESS_HOURS",
PLEASE_ENTER_A_VALID_TIME_START_FOR_BUSINESS_HOURS:"PLEASE_ENTER_A_VALID_TIME_START_FOR_BUSINESS_HOURS",
TIME_BETWEEN_SERVINGS_MUST_BE_GREATER_THAN_0:"TIME_BETWEEN_SERVINGS_MUST_BE_GREATER_THAN_0",
CLEAN_DETECTION_TIME_MUST_BE_GREATER_THAN_0:"CLEAN_DETECTION_TIME_MUST_BE_GREATER_THAN_0",
IS_NOT_ALLOWED_IN_SITE_NAME:"IS_NOT_ALLOWED_IN_SITE_NAME",
SERV_SIZE_MUST_BE_GREATER_THAN_0:"SERV_SIZE_MUST_BE_GREATER_THAN_0",
KEG_SIZE_MUST_BE_GREATER_THAN_0:"KEG_SIZE_MUST_BE_GREATER_THAN_0",
VALIDATE_STRING_LENGTH_ALERT:"VALIDATE_STRING_LENGTH_ALERT",
SECONDS:"SECONDS",
WIRELESS:"WIRELESS",
BUSINESS_HOURS:"BUSINESS_HOURS",
SURE_TO_RESET_THIS_VOLUME:"SURE_TO_RESET_THIS_VOLUME",
VOL_REMAIN:"VOL_REMAIN",
SERVING_REMAIN:"SERVING_REMAIN",
SERV_LEFT:"SERV_LEFT",
SIZE:"SIZE",
SETTINGS:"SETTINGS",
VOLUME_RESET:"VOLUME_RESET",
CLEANING_CYCLE_MODE:"CLEANING_CYCLE_MODE",
CLEANING_CYCLE:"CLEANING_CYCLE",
KEG_SIZE:"KEG_SIZE",
DISPLAY_UNITS:"DISPLAY_UNITS",
US_CEREMONEY:"US_CEREMONEY",
METRIC:"METRIC",
DEVICE_BEACON:"DEVICE_BEACON",
DISABLE:"DISABLE",
ENABLE:"ENABLE",
AUTO_KEG_RESET:"AUTO_KEG_RESET",
CLEANING:"CLEANING",
CLEANING_CYCLE_COMMON_TO_ALL_PORTS:"CLEANING_CYCLE_COMMON_TO_ALL_PORTS",
CLEANING_CYCLE_INDEPENDENT_FOR_EACH_PORT:"CLEANING_CYCLE_INDEPENDENT_FOR_EACH_PORT",
CLEANING_AUTO_DISABLE_MIN:"CLEANING_AUTO_DISABLE_MIN",
MINUTES:"MINUTES",
CLEANING_AUTO_DETECT_SEC:"CLEANING_AUTO_DETECT_SEC",
AUTO_CLEAN_DETECT:"AUTO_CLEAN_DETECT",
AUTO_CLEAN_DETECT_MINUTES:"AUTO_CLEAN_DETECT_MINUTES",
ON:"ON",
OFF:"OFF",
AUTO_CLEAN_DETECT_OFF_NOTE:"AUTO_CLEAN_DETECT_OFF_NOTE",
AUTO_CLEAN_DETECT_MISCONFIGURED:"AUTO_CLEAN_DETECT_MISCONFIGURED",
AUTO_CLEAN_DETECT_RESET_DEFAULT:"AUTO_CLEAN_DETECT_RESET_DEFAULT",
AUTO_CLEAN_DETECT_PENDING_SYNC:"AUTO_CLEAN_DETECT_PENDING_SYNC",
AUTO_CLEAN_DETECT_SERVING_WARN:"AUTO_CLEAN_DETECT_SERVING_WARN",
AUTO_CLEAN_DETECT_CF_OVERRIDE:"AUTO_CLEAN_DETECT_CF_OVERRIDE",
CONTINUOUS_FLOW_MODE:"CONTINUOUS_FLOW_MODE",
SECONGS:"SECONGS",
ALERTS:"ALERTS",
LOW_ALARM:"LOW_ALARM",
NONE:"NONE",
EMAIL_ONLY:"EMAIL_ONLY",
TEXT_ONLY:"TEXT_ONLY",
TEXT:"TEXT",
EMPTY_ALARM:"EMPTY_ALARM",
AFTER_HOURS_ALERTS:"AFTER_HOURS_ALERTS",
TEMPRETURE_ALERTS:"TEMPRETURE_ALERTS",
PRESSURE_ALERTS:"PRESSURE_ALERTS",
DAYS:"DAYS",
OFFLINE_ALERTS:"OFFLINE_ALERTS",
SECONDARY_WIFI_SSID:"SECONDARY_WIFI_SSID",
SECONDARY_WIFI_PASSWORD:"SECONDARY_WIFI_PASSWORD",
BLUETOOTH_ACCESS:"BLUETOOTH_ACCESS",
STOP:"STOP",
ENABLING_CLEANING_MODE_WILL_DISABLE_ALL_MEASUREMENTS:"ENABLING_CLEANING_MODE_WILL_DISABLE_ALL_MEASUREMENTS",
MINUTES_IF_NOT_MANUALLY_DISABLED:"MINUTES_IF_NOT_MANUALLY_DISABLED",
RESET_KEGS_SERVED_COUNT:"RESET_KEGS_SERVED_COUNT",
STATE:"STATE",
UNUSED:"UNUSED",
IN_USE:"IN_USE",
BEACON:"BEACON",
EVENT_HISTORY:"EVENT_HISTORY",
KEG_COUNT_RESET:"KEG_COUNT_RESET",
PRESSURE_A:"PRESSURE_A",
PRESSURE_B:"PRESSURE_B",
MANUAL_UPDATE:"MANUAL_UPDATE",
INVITATION_MSG:"INVITATION_MSG",
RESET_PASS_MSG:"RESET_PASS_MSG",
MANUAL_SERV_DIALOG_HEADER: "MANUAL_SERV_DIALOG_HEADER",
OUNCES: "OUNCES",
MILLILITERS: "MILLILITERS",
MANUAL_SERV_DIALOG_LINE1: "MANUAL_SERV_DIALOG_LINE1",
MANUAL_SERV_DIALOG_LINE2: "MANUAL_SERV_DIALOG_LINE2",
UDP_STREAMING: "UDP_STREAMING",
CHANGE_PRES_TYPE_WARN:"CHANGE_PRES_TYPE_WARN",
CHECK_PRES_THRESHOLDS_A: "CHECK_PRES_THRESHOLDS_A",
CHECK_PRES_THRESHOLDS_B: "CHECK_PRES_THRESHOLDS_B",
DEMO_ALERT_MSG: "DEMO_ALERT_MSG",
FAILED_TOGGLE_CLEAN_MODE: "FAILED_TOGGLE_CLEAN_MODE",
FAILED_RESET_KEG_VOLUME: "FAILED_RESET_KEG_VOLUME",
FAILED_RESET_KEGS_SERVED_COUNT: "FAILED_RESET_KEGS_SERVED_COUNT",
FAILED_SUBMIT_MANUAL_SERVING: "FAILED_SUBMIT_MANUAL_SERVING",
FAILED_UPDATE_PASSWORD: "FAILED_UPDATE_PASSWORD",
CLEAN_MODE_ENABLED: "CLEAN_MODE_ENABLED",
CLEAN_MODE_DISABLED: "CLEAN_MODE_DISABLED",
KEG_VOLUME_RESET_SUCCESS: "KEG_VOLUME_RESET_SUCCESS",
KEGS_SERVED_COUNT_RESET_SUCCESS: "KEGS_SERVED_COUNT_RESET_SUCCESS",
SETTINGS_SAVED_SUCCESS: "SETTINGS_SAVED_SUCCESS",
PASSWORD_UPDATED_SUCCESS: "PASSWORD_UPDATED_SUCCESS",
MANUAL_SERVING_SUBMITTED_SUCCESS: "MANUAL_SERVING_SUBMITTED_SUCCESS",
UNTAPPD_CONNECTED_SUCCESS: "UNTAPPD_CONNECTED_SUCCESS",
FAILED_TO_SAVE_SETTINGS: "FAILED_TO_SAVE_SETTINGS",
DEVICE_OFFLINE_ERROR: "DEVICE_OFFLINE_ERROR",
ON_DECK: "ON_DECK",
KEGS_ON_DECK: "KEGS_ON_DECK",
NEW_KEGS_READY_TO_TAP: "NEW_KEGS_READY_TO_TAP",
COUNT_AUTO_DEDUCTED: "COUNT_AUTO_DEDUCTED",

// Global Configuration
GENERAL: "GENERAL",
PORT_SETTINGS: "PORT_SETTINGS",
GLOBAL_CONFIGURATION: "GLOBAL_CONFIGURATION",
GLOBAL_SETTINGS: "GLOBAL_SETTINGS",
APPLY_TO_ALL_DEVICES: "APPLY_TO_ALL_DEVICES",
UPDATE_SETTINGS_ACROSS_DEVICES: "UPDATE_SETTINGS_ACROSS_DEVICES",
DEVICES_WITH_CUSTOM_VALUES: "DEVICES_WITH_CUSTOM_VALUES",
UPDATE_DEVICE_AS_WELL: "UPDATE_DEVICE_AS_WELL",
OVERWRITE_CUSTOM_VALUE: "OVERWRITE_CUSTOM_VALUE",
MIXED_VALUES: "MIXED_VALUES",
DIFFERENT_VALUES_ACROSS_DEVICES: "DIFFERENT_VALUES_ACROSS_DEVICES",
SAVE_GLOBAL_CONFIGURATION: "SAVE_GLOBAL_CONFIGURATION",
DEVICES_UPDATED: "DEVICES_UPDATED",
DEVICES_SKIPPED_CUSTOM_VALUES: "DEVICES_SKIPPED_CUSTOM_VALUES",
DEVICES_SKIPPED_OFFLINE: "DEVICES_SKIPPED_OFFLINE",
NO_CHANGES_TO_SAVE: "NO_CHANGES_TO_SAVE",

// Icon/Tooltip Text
MATCHES_GLOBAL_SITE_SETTING: "MATCHES_GLOBAL_SITE_SETTING",
CUSTOM_FOR_THIS_DEVICE: "CUSTOM_FOR_THIS_DEVICE",
CUSTOM_FOR_THIS_PORT: "CUSTOM_FOR_THIS_PORT",
GLOBAL_SETTING: "GLOBAL_SETTING",
CUSTOM_VALUE: "CUSTOM_VALUE",
RESET_TO_GLOBAL: "RESET_TO_GLOBAL",
LEGEND_GLOBAL_SETTING: "LEGEND_GLOBAL_SETTING",
LEGEND_CUSTOM_VALUE: "LEGEND_CUSTOM_VALUE",

// Messages
GLOBAL_CONFIG_SAVED: "GLOBAL_CONFIG_SAVED",
GLOBAL_CONFIG_ERROR: "GLOBAL_CONFIG_ERROR",
NO_UNUSED_PORTS: "NO_UNUSED_PORTS",
DEVICE_CUSTOM_VALUE_INFO: "DEVICE_CUSTOM_VALUE_INFO",
PORT_CUSTOM_VALUE_INFO: "PORT_CUSTOM_VALUE_INFO",

// Port deviation table
PORTS_DIFFER_FROM_CONSENSUS_SINGULAR: "PORTS_DIFFER_FROM_CONSENSUS_SINGULAR",
PORTS_DIFFER_FROM_CONSENSUS_PLURAL: "PORTS_DIFFER_FROM_CONSENSUS_PLURAL",
DEVICES_DIFFER_FROM_CONSENSUS_SINGULAR: "DEVICES_DIFFER_FROM_CONSENSUS_SINGULAR",
DEVICES_DIFFER_FROM_CONSENSUS_PLURAL: "DEVICES_DIFFER_FROM_CONSENSUS_PLURAL",
DEVICES_WILL_BE_UPDATED_SINGULAR: "DEVICES_WILL_BE_UPDATED_SINGULAR",
DEVICES_WILL_BE_UPDATED_PLURAL: "DEVICES_WILL_BE_UPDATED_PLURAL",
PORTS_WILL_BE_UPDATED_SINGULAR: "PORTS_WILL_BE_UPDATED_SINGULAR",
PORTS_WILL_BE_UPDATED_PLURAL: "PORTS_WILL_BE_UPDATED_PLURAL",
TABLE_HEADER_NAME: "TABLE_HEADER_NAME",
TABLE_HEADER_TAP_LABEL: "TABLE_HEADER_TAP_LABEL",
TABLE_HEADER_DEVICE: "TABLE_HEADER_DEVICE",
TABLE_HEADER_PORT: "TABLE_HEADER_PORT",
TABLE_HEADER_CURRENT_VALUE: "TABLE_HEADER_CURRENT_VALUE",
TABLE_HEADER_UPDATE: "TABLE_HEADER_UPDATE",

// Error Boundary
ERROR_SOMETHING_WENT_WRONG: "ERROR_SOMETHING_WENT_WRONG",
ERROR_SEE_DETAILS: "ERROR_SEE_DETAILS",
ERROR_LABEL: "ERROR_LABEL",
ERROR_STACK_LABEL: "ERROR_STACK_LABEL",
ERROR_COMPONENT_STACK_LABEL: "ERROR_COMPONENT_STACK_LABEL",
ERROR_RELOAD_PAGE: "ERROR_RELOAD_PAGE",

// Loading states
LOADING: "LOADING",
PROCESSING_UNTAPPD_AUTH: "PROCESSING_UNTAPPD_AUTH",

// Beer details
BEER_STYLE: "BEER_STYLE",
BEER_ABV: "BEER_ABV",
BEER_IBU: "BEER_IBU",

// Alert modal
ALERT: "ALERT",

// Error messages
ERROR_PREFIX: "ERROR_PREFIX",
ERROR_LOADING_GLOBAL_CONFIG: "ERROR_LOADING_GLOBAL_CONFIG",
ERROR_UPDATE_ONDECK_REVERTED: "ERROR_UPDATE_ONDECK_REVERTED",
ERROR_LOADING_DEVICES: "ERROR_LOADING_DEVICES",
ERROR_NETWORK: "ERROR_NETWORK",
RETRY: "RETRY",

// Reports page improvements
LAST_7_DAYS: "LAST_7_DAYS",
LAST_30_DAYS: "LAST_30_DAYS",
LAST_90_DAYS: "LAST_90_DAYS",
SELECT_ALL: "SELECT_ALL",
DESELECT_ALL: "DESELECT_ALL",
TRY_DIFFERENT_DATE_RANGE: "TRY_DIFFERENT_DATE_RANGE",
SELECT_AT_LEAST_ONE_SITE: "SELECT_AT_LEAST_ONE_SITE",
EXPAND_ALL: "EXPAND_ALL",
COLLAPSE_ALL: "COLLAPSE_ALL",
EXPAND_ALL_KEGS: "EXPAND_ALL_KEGS",
COLLAPSE_ALL_KEGS: "COLLAPSE_ALL_KEGS",
EXPAND_ALL_TAPS: "EXPAND_ALL_TAPS",
COLLAPSE_ALL_TAPS: "COLLAPSE_ALL_TAPS",
LOADING_DEVICES: "LOADING_DEVICES",
SERVING_COST: "SERVING_COST",

// Size breakdown for reports
SIZE_BREAKDOWN: "SIZE_BREAKDOWN",
SERVINGS_BY_SIZE: "SERVINGS_BY_SIZE",
STANDARD_SIZE: "STANDARD_SIZE",
VARIANCE: "VARIANCE",
VAR_COLON: "VAR_COLON",
VARIANCE_LOSS: "VARIANCE_LOSS",
VARIANCE_SAVINGS: "VARIANCE_SAVINGS",
SINGLES: "SINGLES",
DOUBLES: "DOUBLES",
TRIPLES: "TRIPLES",
QUADS: "QUADS",
QUINTS: "QUINTS",
OTHER_SIZE: "OTHER_SIZE",

// Mobile abbreviated column headers
SERVINGS_SHORT: "SERVINGS_SHORT",
VOLUME_SERVED_SHORT: "VOLUME_SERVED_SHORT",
VARIANCE_SHORT: "VARIANCE_SHORT",
STANDARD_SIZE_SHORT: "STANDARD_SIZE_SHORT",
SERVING_SIZE_SHORT: "SERVING_SIZE_SHORT",
KEG_NAME_SHORT: "KEG_NAME_SHORT",
SITE_NAME_SHORT: "SITE_NAME_SHORT",
KEGS_SERVED_SHORT: "KEGS_SERVED_SHORT",

// Serving size configuration
SERVING_SIZE_CONFIGURATION: "SERVING_SIZE_CONFIGURATION",
STANDARD_SIZES: "STANDARD_SIZES",
SELECT_SIZES_TO_TRACK: "SELECT_SIZES_TO_TRACK",
CUSTOM_SIZES: "CUSTOM_SIZES",
ADD_CUSTOM_SIZE: "ADD_CUSTOM_SIZE",
REMOVE: "REMOVE",
SAVE_SERVING_SIZE_CONFIG: "SAVE_SERVING_SIZE_CONFIG",
SERVING_SIZE_CONFIG_SAVED: "SERVING_SIZE_CONFIG_SAVED",
SERVING_SIZE_CONFIG_ERROR: "SERVING_SIZE_CONFIG_ERROR",
OVERRIDE_SERVING_SIZES: "OVERRIDE_SERVING_SIZES",
USE_GLOBAL_CONFIG: "USE_GLOBAL_CONFIG",
SIZE_ML: "SIZE_ML",
SIZE_OZ: "SIZE_OZ",
SIZE_NAME: "SIZE_NAME",
CUSTOM_SIZE_NAME_PLACEHOLDER: "CUSTOM_SIZE_NAME_PLACEHOLDER",

// Per-tap serving sizes (single source of truth)
STANDARD_SIZES_LABEL: "STANDARD_SIZES_LABEL",
AVAILABLE_SERVING_SIZES: "AVAILABLE_SERVING_SIZES",
DEFINE_AVAILABLE_SIZES: "DEFINE_AVAILABLE_SIZES",
PER_TAP_SERVING_SIZES: "PER_TAP_SERVING_SIZES",
SELECT_TAP_SIZES: "SELECT_TAP_SIZES",
SELECT_SITE_FOR_TAP_CONFIG: "SELECT_SITE_FOR_TAP_CONFIG",
DEFAULT_SIZE: "DEFAULT_SIZE",
TAPS: "TAPS",
APPLY_AVAIL_SIZES_ALL_TAPS: "APPLY_AVAIL_SIZES_ALL_TAPS",
APPLY_AVAIL_SIZES_N_TAPS: "APPLY_AVAIL_SIZES_N_TAPS",

// Serving size tolerance
SERVING_SIZE_TOLERANCE: "SERVING_SIZE_TOLERANCE",
TOLERANCE_HELP_TEXT: "TOLERANCE_HELP_TEXT",
TOLERANCE_TIP: "TOLERANCE_TIP",

// Split pour time threshold
SPLIT_POUR_THRESHOLD: "SPLIT_POUR_THRESHOLD",
SPLIT_POUR_THRESHOLD_HELP: "SPLIT_POUR_THRESHOLD_HELP",

// Table header units
VOLUME_L: "VOLUME_L",
VOLUME_GAL: "VOLUME_GAL",
SERVING_SIZE_ML: "SERVING_SIZE_ML",
SERVING_SIZE_OZ: "SERVING_SIZE_OZ",
COST_CURRENCY: "COST_CURRENCY",
VALUE_CURRENCY: "VALUE_CURRENCY",
LEVEL_PERCENT: "LEVEL_PERCENT",

// POS Mapping
POS_MAPPING: "POS_MAPPING",
POS_MAPPING_LINK: "POS_MAPPING_LINK",
POS_PROVIDER: "POS_PROVIDER",
SELECT_PROVIDER: "SELECT_PROVIDER",
SQUARE: "SQUARE",
CLOVER_COMING_SOON: "CLOVER_COMING_SOON",
LIGHTSPEED_COMING_SOON: "LIGHTSPEED_COMING_SOON",
NOT_CONNECTED_DEMO_DATA: "NOT_CONNECTED_DEMO_DATA",
TOTAL_TAPS: "TOTAL_TAPS",
MAPPED: "MAPPED",
UNMAPPED: "UNMAPPED",
VARIATIONS: "VARIATIONS",
NOT_MAPPED: "NOT_MAPPED",
N_SIZES: "N_SIZES",
SQUARE_POS_ITEM: "SQUARE_POS_ITEM",
LINK_TO_SQUARE_POS_ITEM: "LINK_TO_SQUARE_POS_ITEM",
SEARCH_SQUARE_CATALOG: "SEARCH_SQUARE_CATALOG",
LIGHTSPEED_POS_ITEM: "LIGHTSPEED_POS_ITEM",
LINK_TO_LIGHTSPEED_POS_ITEM: "LINK_TO_LIGHTSPEED_POS_ITEM",
SEARCH_LIGHTSPEED_CATALOG: "SEARCH_LIGHTSPEED_CATALOG",
ADD_LIGHTSPEED_ITEM: "ADD_LIGHTSPEED_ITEM",
CLEAR: "CLEAR",
SERVING_SIZE_DEFINED_ON_REPORTS: "SERVING_SIZE_DEFINED_ON_REPORTS",
SAVE_MAPPING: "SAVE_MAPPING",
UNSAVED_CHANGES: "UNSAVED_CHANGES",
SAVED_JUST_NOW: "SAVED_JUST_NOW",
MAPPING_SAVED: "MAPPING_SAVED",
MAPPING_SAVE_FAILED: "MAPPING_SAVE_FAILED",
POS_DEMO_MODE_SAVE_DISABLED: "POS_DEMO_MODE_SAVE_DISABLED",
POS_DEMO_MODE_CONNECTION_DISABLED: "POS_DEMO_MODE_CONNECTION_DISABLED",
SELECT_SIZE: "SELECT_SIZE",
UNKNOWN_SIZE: "UNKNOWN_SIZE",
UNKNOWN_VARIATION: "UNKNOWN_VARIATION",
SELECT_PROVIDER_FIRST: "SELECT_PROVIDER_FIRST",
NO_TAPS_FOUND: "NO_TAPS_FOUND",
DEVICE_PORT: "DEVICE_PORT",
CONNECT_SQUARE: "CONNECT_SQUARE",
DISCONNECT_SQUARE: "DISCONNECT_SQUARE",
SQUARE_CONNECTED: "SQUARE_CONNECTED",
SQUARE_CONNECT_FAILED: "SQUARE_CONNECT_FAILED",
SQUARE_CONNECTING: "SQUARE_CONNECTING",
SQUARE_CONNECTION_EXPIRED: "SQUARE_CONNECTION_EXPIRED",
SQUARE_CONNECTED_STATUS: "SQUARE_CONNECTED_STATUS",
SQUARE_NOT_CONNECTED_STATUS: "SQUARE_NOT_CONNECTED_STATUS",
PROCESSING_SQUARE_AUTH: "PROCESSING_SQUARE_AUTH",
SQUARE_LOCATION: "SQUARE_LOCATION",
SELECT_LOCATION: "SELECT_LOCATION",
LOCATION_REQUIRED: "LOCATION_REQUIRED",
POS_VARIANCE_TAB: "POS_VARIANCE_TAB",
POS_VARIANCE: "POS_VARIANCE",
POS_NOT_CONNECTED: "POS_NOT_CONNECTED",
POS_NOT_CONNECTED_SITE: "POS_NOT_CONNECTED_SITE",
POS_NO_MAPPING: "POS_NO_MAPPING",
POS_NO_MAPPED_TAPS: "POS_NO_MAPPED_TAPS",
POS_SETUP_LINK: "POS_SETUP_LINK",
POS_LOADING_ORDERS: "POS_LOADING_ORDERS",
POS_ORDERS_ERROR: "POS_ORDERS_ERROR",
POS_RETRY: "POS_RETRY",
POS_CATALOG_LOAD_ERROR: "POS_CATALOG_LOAD_ERROR",
POURED: "POURED",
SOLD: "SOLD",
DETECTED: "DETECTED",
COUNT_VARIANCE: "COUNT_VARIANCE",
POS_NOT_MAPPED_TAP: "POS_NOT_MAPPED_TAP",

// Keg detail hierarchy (Phase 4)
SERVINGS_REMAINING: "SERVINGS_REMAINING",
POUR_HISTORY: "POUR_HISTORY",
DETAILS: "DETAILS",
DEVICE_ID: "DEVICE_ID",

// Site table — status dot titles & display strings
STATUS_OFFLINE: "STATUS_OFFLINE",
STATUS_ONLINE: "STATUS_ONLINE",
STATUS_UNUSED: "STATUS_UNUSED",
STATUS_CLEANING: "STATUS_CLEANING",
TODAY_ON_TAP: "TODAY_ON_TAP",
PORT_LABEL: "PORT_LABEL",

// Site table — icon-only link aria-labels
CONFIGURE_TAP_SETTINGS: "CONFIGURE_TAP_SETTINGS",

// POS provider abstraction
POS_PROVIDER_SQUARE: "pos_provider_square",
POS_PROVIDER_LIGHTSPEED: "pos_provider_lightspeed",
POS_PROVIDER_NOT_CONNECTED: "pos_provider_not_connected",
POS_PROVIDER_UNKNOWN: "pos_provider_unknown",
POS_RECONNECT_REQUIRED: "pos_reconnect_required",

// Lightspeed OAuth & connection UI
LIGHTSPEED: "LIGHTSPEED",
POS_CONNECT_LIGHTSPEED: "pos_connect_lightspeed",
POS_DISCONNECT: "pos_disconnect",
POS_CONNECTED_TO: "pos_connected_to",
POS_SELECT_LOCATION: "pos_select_location",
POS_CONFIRM_LOCATION: "pos_confirm_location",
POS_NO_LOCATIONS: "pos_no_locations",
POS_NO_ITEMS_FOUND: "pos_no_items_found",
POS_NO_SALES_DATA: "pos_no_sales_data",
POS_AUTH_FAILED: "pos_auth_failed",
POS_RECONNECT: "pos_reconnect",
POS_RECONNECT_MSG: "pos_reconnect_msg",
POS_CONNECTING: "pos_connecting",
PROCESSING_LIGHTSPEED_AUTH: "processing_lightspeed_auth",
POS_DISCONNECT_TITLE: "pos_disconnect_title",
POS_DISCONNECT_CONFIRM_MSG: "pos_disconnect_confirm_msg",
POS_ACCOUNT_CONNECTED: "pos_account_connected",

// POS Mapping — item swap + add size
CHANGE_SQUARE_ITEM: "CHANGE_SQUARE_ITEM",
SEARCH_TO_CHANGE_ITEM: "SEARCH_TO_CHANGE_ITEM",
ADD_SERVING_SIZE: "ADD_SERVING_SIZE",

// App update prompt (new deployment detected)
APP_UPDATE_AVAILABLE: "APP_UPDATE_AVAILABLE",
APP_UPDATE_RELOAD: "APP_UPDATE_RELOAD",

// Account page errors
FAILED_LOAD_ACCOUNT_DATA: "FAILED_LOAD_ACCOUNT_DATA",

// Keg page — manual serving validation
MANUAL_SERVING_INVALID_VALUE: "MANUAL_SERVING_INVALID_VALUE",

// Settings — dispense mode dropdown
DISPENSE_MODE: "DISPENSE_MODE",
DISPENSE_ALWAYS_FREE_FLOW: "DISPENSE_ALWAYS_FREE_FLOW",
DISPENSE_ALWAYS_CLOSED: "DISPENSE_ALWAYS_CLOSED",
DISPENSE_FREE_FLOW_BIZ_HOURS: "DISPENSE_FREE_FLOW_BIZ_HOURS",
DISPENSE_FIXED_BIZ_HOURS: "DISPENSE_FIXED_BIZ_HOURS",
DISPENSE_FIXED_ANY_TIME: "DISPENSE_FIXED_ANY_TIME",

// API error handler
TOO_MANY_REQUESTS: "TOO_MANY_REQUESTS",

// Reports — partial servings data (timed-out / failed devices)
SERVINGS_PARTIAL_WARNING: "SERVINGS_PARTIAL_WARNING",
SERVINGS_PARTIAL_MISSING: "SERVINGS_PARTIAL_MISSING",
RETRY_MISSING: "RETRY_MISSING",
SERVINGS_PARTIAL_RETRY_HINT: "SERVINGS_PARTIAL_RETRY_HINT",
CSV_PARTIAL_WARNING: "CSV_PARTIAL_WARNING",
GET_THE_APP:"GET_THE_APP",
CONTINUE_IN_BROWSER:"CONTINUE_IN_BROWSER",
DEVICE_ADDED:"DEVICE_ADDED",
DEVICE_ALREADY_ADDED:"DEVICE_ALREADY_ADDED",
INVALID_DEVICE_KEY:"INVALID_DEVICE_KEY",
ADDING_DEVICE:"ADDING_DEVICE",
WAITING_FOR_DEVICE_ONLINE:"WAITING_FOR_DEVICE_ONLINE",
APP_LANDING_INTRO:"APP_LANDING_INTRO",
DOWNLOAD_APP_STORE:"DOWNLOAD_APP_STORE",
DOWNLOAD_GOOGLE_PLAY:"DOWNLOAD_GOOGLE_PLAY",

// Reports rebuild (2026)
SERVED_TAB:"SERVED_TAB",
PREVIOUS_PERIOD:"PREVIOUS_PERIOD",
NEXT_PERIOD:"NEXT_PERIOD",
SHOW_MORE:"SHOW_MORE",
POUR_LOG:"POUR_LOG",
DEMO_MODE_RESTRICTION:"DEMO_MODE_RESTRICTION",
AS_OF:"AS_OF",
KEGS_ON_TAP:"KEGS_ON_TAP",
VOLUME_REMAINING:"VOLUME_REMAINING",
SHOW_LOSSES_ONLY:"SHOW_LOSSES_ONLY",
SHOW_TIMESTAMPS:"SHOW_TIMESTAMPS",
FIRST_POUR:"FIRST_POUR",
LAST_POUR:"LAST_POUR",
SPLASH_POUR:"SPLASH_POUR",
UNMATCHED_POUR:"UNMATCHED_POUR",

// Cleaning report (2026)
CLEANING_REPORT:"CLEANING_REPORT",
DAYS_SINCE_CLEANING:"DAYS_SINCE_CLEANING",
CLEANING_STATUS:"CLEANING_STATUS",
STATUS_UP_TO_DATE:"STATUS_UP_TO_DATE",
STATUS_OVERDUE:"STATUS_OVERDUE",
STATUS_NOT_RECORDED:"STATUS_NOT_RECORDED",
TAPS_TRACKED:"TAPS_TRACKED",
CLEANED_LAST_7_DAYS:"CLEANED_LAST_7_DAYS",
CURRENTLY_CLEANING:"CURRENTLY_CLEANING",
STATUS_DUE_FOR_CLEANING:"STATUS_DUE_FOR_CLEANING",
NEEDS_CLEANING:"NEEDS_CLEANING",
CLEANINGS_LOGGED:"CLEANINGS_LOGGED",
CLEANING_LOG:"CLEANING_LOG",
CLEANING_TYPE:"CLEANING_TYPE",
CLEANING_TYPE_AUTO:"CLEANING_TYPE_AUTO",
CLEANING_TYPE_MANUAL:"CLEANING_TYPE_MANUAL",
NO_CLEANINGS_IN_WINDOW:"NO_CLEANINGS_IN_WINDOW",
CLEANING_LOG_WINDOW_NOTE:"CLEANING_LOG_WINDOW_NOTE",
LOADING_CLEANING_HISTORY:"LOADING_CLEANING_HISTORY",

// Billing / subscription (2026)
BILLING_SUBSCRIPTION:"BILLING_SUBSCRIPTION",
BILLING_PLAN_STATUS:"BILLING_PLAN_STATUS",
BILLING_STATE_UNSUBSCRIBED:"BILLING_STATE_UNSUBSCRIBED",
BILLING_STATE_ACTIVE:"BILLING_STATE_ACTIVE",
BILLING_STATE_GRACE:"BILLING_STATE_GRACE",
BILLING_STATE_PENDING_SUSPENSION:"BILLING_STATE_PENDING_SUSPENSION",
BILLING_STATE_SUSPENDED:"BILLING_STATE_SUSPENDED",
BILLING_PAID_PORTS:"BILLING_PAID_PORTS",
BILLING_PORTS_IN_USE:"BILLING_PORTS_IN_USE",
BILLING_NEXT_RENEWAL:"BILLING_NEXT_RENEWAL",
BILLING_MANAGE_SUBSCRIPTION:"BILLING_MANAGE_SUBSCRIPTION",
BILLING_SETUP_SUBSCRIPTION:"BILLING_SETUP_SUBSCRIPTION",
BILLING_OVER_PORTS_NOTE:"BILLING_OVER_PORTS_NOTE",
BILLING_PORTS_CURRENT:"BILLING_PORTS_CURRENT",
BILLING_BANNER_OVER_PORTS:"BILLING_BANNER_OVER_PORTS",
BILLING_ADD_PORTS:"BILLING_ADD_PORTS",
BILLING_USAGE_LINE:"BILLING_USAGE_LINE",
BILLING_PAUSED_NOTE:"BILLING_PAUSED_NOTE",
BILLING_PORTAL_ERROR:"BILLING_PORTAL_ERROR",
BILLING_BANNER_UNSUBSCRIBED:"BILLING_BANNER_UNSUBSCRIBED",
BILLING_BANNER_ACTION_NEEDED:"BILLING_BANNER_ACTION_NEEDED",
BILLING_BANNER_ACTION_NEEDED_SOON:"BILLING_BANNER_ACTION_NEEDED_SOON",
BILLING_BANNER_MANAGE:"BILLING_BANNER_MANAGE",
BILLING_DISMISS:"BILLING_DISMISS",
BILLING_SUSPENDED_TITLE:"BILLING_SUSPENDED_TITLE",
BILLING_SUSPENDED_BODY:"BILLING_SUSPENDED_BODY",
BILLING_SUSPENDED_DEVICES_NOTE:"BILLING_SUSPENDED_DEVICES_NOTE",
BILLING_SUSPENDED_RESTORE_NOTE:"BILLING_SUSPENDED_RESTORE_NOTE",
BILLING_CONTACT_SUPPORT:"BILLING_CONTACT_SUPPORT",
BILLING_CHECKOUT_SUCCESS:"BILLING_CHECKOUT_SUCCESS",

// /subscribe route
SUBSCRIBE_PAGE_TITLE:"SUBSCRIBE_PAGE_TITLE",
SUBSCRIBE_UNAVAILABLE:"SUBSCRIBE_UNAVAILABLE",
SUBSCRIBE_NOT_NEEDED:"SUBSCRIBE_NOT_NEEDED",
SUBSCRIBE_NO_OPTIONS:"SUBSCRIBE_NO_OPTIONS",
SUBSCRIBE_CHOOSE_PLAN:"SUBSCRIBE_CHOOSE_PLAN",
SUBSCRIBE_PLAN_NAME_MONTHLY:"SUBSCRIBE_PLAN_NAME_MONTHLY",
SUBSCRIBE_PLAN_PRICE_MONTHLY:"SUBSCRIBE_PLAN_PRICE_MONTHLY",
SUBSCRIBE_PLAN_NAME_ANNUAL:"SUBSCRIBE_PLAN_NAME_ANNUAL",
SUBSCRIBE_PLAN_PRICE_ANNUAL:"SUBSCRIBE_PLAN_PRICE_ANNUAL",
SUBSCRIBE_PLAN_NAME_LIFETIME:"SUBSCRIBE_PLAN_NAME_LIFETIME",
SUBSCRIBE_PLAN_PRICE_LIFETIME:"SUBSCRIBE_PLAN_PRICE_LIFETIME",
SUBSCRIBE_QUANTITY_LABEL:"SUBSCRIBE_QUANTITY_LABEL",
SUBSCRIBE_QUANTITY_INVALID:"SUBSCRIBE_QUANTITY_INVALID",
SUBSCRIBE_CTA:"SUBSCRIBE_CTA",
SUBSCRIBE_CHECKOUT_ERROR:"SUBSCRIBE_CHECKOUT_ERROR",
SUBSCRIBE_CHECKOUT_CANCELED:"SUBSCRIBE_CHECKOUT_CANCELED",
SUBSCRIBE_LEGACY_NOTE:"SUBSCRIBE_LEGACY_NOTE",
SUBSCRIBE_MANAGE_EXISTING_NOTE:"SUBSCRIBE_MANAGE_EXISTING_NOTE",
BACK_TO_ACCOUNT:"BACK_TO_ACCOUNT",

}
export {
    AppConstant
}